const deleteMessageEffect = (_effect, action, { gccApiClient }) => {
  const { messageId } = action.meta;

  return gccApiClient.updateMessage(messageId, {
    deleted: true,
  });
};

export default deleteMessageEffect;
